import React, {useEffect} from 'react';
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import {Alert, Autocomplete, Stack} from "@mui/material";
import {countryArray, eventStatus, getCountryName, getRlPilot} from "../../util/standards-util";
import Grid2 from "@mui/material/Unstable_Grid2";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import {ArrowBack} from "@mui/icons-material";
import {findFlagUrlByIso2Code} from 'country-flags-svg';
import RegistrationStatusWidget from "../../components/Event/RegistrationStatusWidget";
import RegistrationStatusPilotWidget from "../../components/Event/RegistrationStatusPilotWidget";
import {
    useUpdateCompetitionRegistrationDetailsMutation,
} from "../../slices/apiSlice";
import WildcardWidget from "../../components/Event/WildcardWidget";
import {useSelector} from "react-redux";

const PilotInfo2 = ({entry, event, hasWildcardAvailable, isAdminMode = true, isModal = true, onPilotRegistrationUpdate = ()=>{}, onPilotDetailsUpdate = ()=>{}, onClose = ()=>{}}) => {
    const session = useSelector(state => state.session)

    const registration = entry.registration
    const details = entry.details
    const pilot = entry.pilot

    const textFieldVariant = 'standard'

    const [rlData, setRlData] = React.useState()
    const [updateValues, setUpdateValues] = React.useState({})
    const [isChanged, setIsChanged] = React.useState(false)
    const [isOwner, setIsOwner] = React.useState(false)

    const [save, saveResult] =
        useUpdateCompetitionRegistrationDetailsMutation()

    const handleSubmit = () => {
        
    }

    const cancelEdit = () => {
        onClose()

    }

    const saveEdit = () => {
        if (isChanged && event.status !== eventStatus.STATUS_COMPLETED) {
            save({
                id: registration.i,
                eventId: event.id,
                ...updateValues
            })
        }
    }

    const handleValueChanged = (e) => {
        const id = e.target.id
        const val = e.target.value
        if (e.target.defaultValue !== val) {
            updateValues[id] = val
            setUpdateValues(updateValues)
            if (event.status !== eventStatus.STATUS_COMPLETED) setIsChanged(true)

            console.log(updateValues)

            if (id === 'igcRankingId' && val && !isNaN(val)) {
                getRlPilot(val,(data)=>{
                    if (data.status==='OK') {
                        const nationalityLabel = getCountryName(data.data.nationality)
                        data.data.nationalityLabel = nationalityLabel ? nationalityLabel : data.data.nationality
                        setRlData(data.data)
                    }
                })
            }
        }
    }

    const handleCountryChange = (e, value) => {
        const country = value?.key
        handleValueChanged({
            target:{
                id:'country',
                value:country,
            }
        })
    }

    useEffect(() => {
        if (entry.details.igcRankingId && !isNaN(entry.details.igcRankingId)) {
            getRlPilot(entry.details.igcRankingId,(data)=>{
                if (data.status==='OK') {
                    const nationalityLabel = getCountryName(data.data.nationality)
                    data.data.nationalityLabel = nationalityLabel ? nationalityLabel : data.data.nationality
                    setRlData(data.data)
                }
            })
        }
    }, []);

    useEffect(() => {
        if (saveResult.isSuccess) {
            onPilotDetailsUpdate(saveResult.data.data)
            setIsChanged(false)
            onClose()
        }
    }, [saveResult]);

    useEffect(() => {
        setIsOwner(session.pilot?.id === entry.registration.p)
    }, [session.pilot]);

    const handleKeyPressed = (e) => {
        if (e.key==='Enter') {
            e.target.blur()
        }
    }

    return (
        <>
            <Box sx={{
                display:'flex',
                alignItems:'center',
                //justifyContent:'space-between',
                mt:'1em',
                columnGap:'2em',
                mb:'2em',
            }}>
                {isModal && <IconButton onClick={onClose}><ArrowBack/></IconButton>}
                <Typography variant={'h5'} flexGrow={1} textAlign={'left'} component={'div'} sx={{display:'flex',alignItems:'center'}}>
                    {entry.pilot.firstname} {entry.pilot.lastname}
                    <img src={findFlagUrlByIso2Code(entry.pilot.nationality)} style={{height:'1em',marginLeft:'1em'}}/>
                </Typography>
                {isAdminMode && <WildcardWidget entry={entry} hasWildcardAvailable={hasWildcardAvailable} onUpdate={(val) => {onPilotRegistrationUpdate(val);onClose()}}/>}
                {isAdminMode && <RegistrationStatusWidget entry={entry} event={event} onUpdate={(val)=>{onPilotRegistrationUpdate(val);onClose()}}/>}
                {isOwner && <RegistrationStatusPilotWidget entry={entry} event={event} onUpdate={(val)=>{onPilotRegistrationUpdate(val);onClose()}}/>}
                {isChanged &&
                    <Box>
                        <Button onClick={cancelEdit} variant={'outlined'} color={'warning'} size={'small'} sx={{mr:'1em'}}>Cancel</Button>
                        <Button onClick={saveEdit} variant={'contained'} color={'warning'} size={'small'}>Save</Button>
                    </Box>
                }
            </Box>
            <Box component="form" onSubmit={handleSubmit} noValidate>
                <Grid2 spacing={4} container sx={{alignItems:'stretch'}}>
                    <Grid2 xs={12} md={6}>
                        <Paper elevation={2} square sx={{height:'100%'}}>
                            <Stack pt={2} pb={4} px={4} spacing={2}>
                                <Typography variant={'h6'} component={'div'}>
                                    Pilot info
                                </Typography>
                                <TextField variant={textFieldVariant} id="pilot" name="pilot" label="Pilot"  value={`${pilot.firstname} ${pilot.lastname}`}/>
                                <TextField variant={textFieldVariant} id="email" name="email" label="Email"  value={details.email}/>
                                <TextField variant={textFieldVariant} id="nationality" name="nationality" label="Nationality"  value={countryArray.find( c => c.key===pilot.nationality).label}/>
                            </Stack>
                        </Paper>
                    </Grid2>
                    <Grid2 xs={12} md={6}>
                        <Paper elevation={2} square sx={{height:'100%'}}>
                            <Stack pt={2} pb={4} px={4} spacing={2}>
                                <Typography variant={'h6'} component={'div'}>
                                    Sporting info
                                </Typography>
                                <TextField variant={textFieldVariant} id="igcRankingId" name="igcRankingId" label="IGC Ranking List ID"  defaultValue={details.igcRankingId} onBlur={handleValueChanged} onKeyDown={handleKeyPressed}/>
                                {rlData &&
                                    <Box sx={{textAlign:'left'}}>
                                        <Typography variant={'body1'} sx={{fontWeight:700}}>IGC Ranking List Data</Typography>
                                        <Box mb={2}>{rlData.firstname} {rlData.surname} {rlData.nationalityLabel ? ' ('+rlData.nationalityLabel+')' : ''}</Box>
                                        {rlData.surname !==pilot.lastname && rlData.firstname !==pilot.firstname &&
                                            <Alert severity={'error'}>Please check IGC RL ID for match to pilot</Alert>
                                        }
                                        {rlData.surname ===pilot.lastname && rlData.firstname ===pilot.firstname &&
                                            <Alert severity={'success'}>IGC RL data matches pilot</Alert>
                                        }
                                        {(rlData.surname !==pilot.lastname || rlData.firstname !==pilot.firstname) &&
                                            !(rlData.surname !==pilot.lastname && rlData.firstname !==pilot.firstname) &&
                                            <Alert severity={'warning'}>Please check IGC RL data matches pilot information</Alert>
                                        }
                                    </Box>
                                }
                            </Stack>
                        </Paper>
                    </Grid2>
                    <Grid2 xs={12} md={6}>
                        <Paper elevation={2} square sx={{height:'100%'}}>
                            <Stack pt={2} pb={4} px={4} spacing={2}>
                                <Typography variant={'h6'} component={'div'}>
                                    Sailplane info
                                </Typography>
                                <TextField variant={textFieldVariant} id="gliderDescription" name="gliderDescription" label="Sailplane type" defaultValue={details.gliderDescription} onBlur={handleValueChanged} onKeyDown={handleKeyPressed}/>
                                <TextField variant={textFieldVariant} id="compId" name="compId" label="Sailplane competition ID"  defaultValue={details.compId} onBlur={handleValueChanged} onKeyDown={handleKeyPressed}/>
                                <TextField variant={textFieldVariant} id="sailplaneRegistration" name="sailplaneRegistration" label="Sailplane registration"  defaultValue={details.sailplaneRegistration} onBlur={handleValueChanged} onKeyDown={handleKeyPressed}/>
                            </Stack>
                        </Paper>
                    </Grid2>
                    <Grid2 xs={12} md={6}>
                        <Paper elevation={2} square sx={{height:'100%'}}>
                            <Stack pt={2} pb={4} px={4} spacing={2}>
                                <Typography variant={'h6'} component={'div'}>
                                    Logger & tracking info
                                </Typography>

                                <TextField variant={textFieldVariant} id="primaryLoggerSerial" name="primaryLoggerSerial" label="Primary logger serial number"  defaultValue={details.primaryLoggerSerial} onBlur={handleValueChanged} onKeyDown={handleKeyPressed}/>
                                <TextField variant={textFieldVariant} id="secondaryLoggerSerial" name="secondaryLoggerSerial" label="Secondary logger serial number"   defaultValue={details.secondaryLoggerSerial} onBlur={handleValueChanged} onKeyDown={handleKeyPressed}/>
                                <TextField variant={textFieldVariant} id="flarmId" name="flarmId" label="Flarm ID"  defaultValue={details.flarmId} onBlur={handleValueChanged} onKeyDown={handleKeyPressed}/>
                            </Stack>
                        </Paper>
                    </Grid2>
                    <Grid2 xs={12} md={6}>
                        <Paper elevation={2} square sx={{height:'100%'}}>
                            <Stack pt={2} pb={4} px={4} spacing={2}>
                                <Typography variant={'h6'} component={'div'}>
                                    Contact details
                                </Typography>

                                <TextField variant={textFieldVariant} id="phone" name="phone" label="Mobile number"  defaultValue={details.phone} onBlur={handleValueChanged} onKeyDown={handleKeyPressed}/>

                                <Box sx={{display:'flex',flexDirection:'column',alignItems:'stretch',rowGap:'.5em'}}>
                                    <TextField variant={textFieldVariant} id="address1" name="address1" label="Street address" defaultValue={details.address1} onBlur={handleValueChanged} onKeyDown={handleKeyPressed}/>
                                    <TextField variant={textFieldVariant} id="address2" name="address2" label="Street address 2" defaultValue={details.address2} onBlur={handleValueChanged} onKeyDown={handleKeyPressed}/>
                                    <TextField variant={textFieldVariant} id="city" name="city" label="City" defaultValue={details.city} onBlur={handleValueChanged} onKeyDown={handleKeyPressed}/>
                                    <TextField variant={textFieldVariant} id="zipcode" name="zipcode" label="Postal code" defaultValue={details.zipcode} onBlur={handleValueChanged} onKeyDown={handleKeyPressed}/>
                                    <TextField variant={textFieldVariant} id="region" name="region" label="State / Province / Region" defaultValue={details.region} onBlur={handleValueChanged} onKeyDown={handleKeyPressed}/>
                                    <Autocomplete
                                        disablePortal
                                        selectOnFocus
                                        clearOnBlur
                                        handleHomeEndKeys
                                        isOptionEqualToValue={(option,value)=>option.key===value.key}
                                        getOptionLabel={option => getCountryName(option.key)}
                                        id="country"
                                        name="country"
                                        options={countryArray}
                                        renderInput={(params) => <TextField {...params}  variant={textFieldVariant} label="Country" />}
                                        onChange={handleCountryChange}
                                        defaultValue={countryArray.find( c => c.key===details.country)}
                                    />
                                </Box>
                            </Stack>
                        </Paper>
                    </Grid2>
                    <Grid2 xs={12} md={6}>
                        <Paper elevation={2} square sx={{height:'100%'}}>
                            <Stack pt={2} pb={4} px={4} spacing={2}>
                                <Typography variant={'h6'} component={'div'}>
                                    Contact info during competition
                                </Typography>

                                <TextField variant={textFieldVariant} id="competitionPhone" name="competitionPhone" label="Mobile number during competition (if different)" defaultValue={details.competitionPhone} onBlur={handleValueChanged} onKeyDown={handleKeyPressed}/>
                                <TextField variant={textFieldVariant} id="crewName" name="crewName" label="Crew name"  defaultValue={details.crewName} onBlur={handleValueChanged} onKeyDown={handleKeyPressed}/>
                                <TextField variant={textFieldVariant} id="crewPhone" name="crewPhone" label="Crew mobile number"  defaultValue={details.crewPhone} onBlur={handleValueChanged} onKeyDown={handleKeyPressed}/>
                                <TextField variant={textFieldVariant} id="crewCompetitionPhone" name="crewCompetitionPhone" label="Crew secondary mobile number"  defaultValue={details.crewCompetitionPhone} onBlur={handleValueChanged} onKeyDown={handleKeyPressed}/>
                                <TextField variant={textFieldVariant} id="crewEmail" name="crewEmail" label="Crew email"  defaultValue={details.crewEmail} onBlur={handleValueChanged} onKeyDown={handleKeyPressed}/>
                            </Stack>
                        </Paper>
                    </Grid2>
                </Grid2>
            </Box>
        </>
    );
};

export default PilotInfo2;